<template>
    <md-field :class="fieldClass">
        <label>
            {{ $t('registration.entity-type') }}
        </label>

        <md-select
            v-model="entity_type_id"
            :name="name"
            :disabled="disabled"
            @md-selected="selected"
            dusk="country-input"
        >
            <md-option
                v-for="entityType in entityTypes"
                :key="entityType.id"
                :value="entityType.id"
            >
                {{ entityType.name }}
            </md-option>
        </md-select>

        <span class="md-error">
            {{ errors && errors.length ? errors[0] : '' }}
        </span>
    </md-field>
</template>

<script>
export default {
    props: {
        fieldClass: {
            type: Object,
            default: () => {{}}
        },
        errors: {
            type: Array,
            default: () => []
        },
        name: {
            type: String,
            default: 'country_id'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        entityTypeId: {
            type: Number,
            default: null
        },
    },
    data() {
        return {
            entity_type_id: null,
            entityTypes: false,
        };
    },
    watch: {
        entityTypeId(value) {
            if (this.entityTypeId) {
                this.entity_type_id = this.entityTypeId;
            }
        },
    },
    mounted() {
        if (this.entityTypeId) {
            this.entity_type_id = this.entityTypeId;
        }

        this.initSource();
    },
    methods: {
        initSource() {
            axios.get('/api/entity-types').then((response) => {
                this.entityTypes = response.data;
            });
        },
        selected(value) {
            this.$emit('on-change', value);
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/EntityTypeSelector.vue